import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportFiltersFacade } from './transport-filters.facade';

@Injectable({
  providedIn: 'root',
})
export class TransportFiltersGuard {
  constructor(private transportFiltersFacade: TransportFiltersFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.transportFiltersFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportFiltersFacade);
  }
}
